import { z } from "zod";

export const updateAccountPayloadSchema = z.object({
  q: z.string().optional(),
  email: z.string(),
  personalConsent: z.boolean(),
  adConsent: z.boolean(),
  emailConsent: z.boolean(),
  smsConsent: z.boolean(),
});

export type UpdateAccountPayloadType = z.infer<typeof updateAccountPayloadSchema>;
